import { serializable, alias, primitive, object } from 'serializr';
import { Role } from './role.model';

export class User {
  @serializable(alias('email', primitive()))
  email?: string;

  @serializable(alias('id', primitive()))
  id?: string;

  @serializable(alias('name', primitive()))
  name?: string;

  @serializable(object(Role))
  role?: Role;

  @serializable
  company?: string;
}
